import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';
import PaymentsInsuranceFieldsContainerInner from './PaymentsInsuranceFieldsContainerInner';

export { mapFormValuesToWrapperFormat, syncWrapperValuesToParentForm } from './utils/paymentsInsuranceValueMapping';

// Wrapper component to access form state
const PaymentsInsuranceFieldsContainerWrapper = (props) => {
  const { values, initialValues } = useFormState({ subscription: { values: true, initialValues: true } });

  const { index } = props;
  const currentValues = values?.insurance?.[index] || {};
  const initialInsuranceValues = initialValues?.insurance?.[index] || {};

  return (
    <PaymentsInsuranceFieldsContainerInner
      {...props}
      currentValues={currentValues}
      initialValues={initialInsuranceValues}
      submitFailed={props.submitFailed}
    />
  );
};

PaymentsInsuranceFieldsContainerWrapper.propTypes = {
  fieldPrefix: PropTypes.string.isRequired,
  contactId: PropTypes.string,
  form: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  submitFailed: PropTypes.bool,
};

PaymentsInsuranceFieldsContainerWrapper.defaultProps = {
  contactId: '',
  submitFailed: false,
};

export default PaymentsInsuranceFieldsContainerWrapper;
